import { ReviewsAnalyticsAPI } from '@weave/schema-gen-ts/dist/schemas/reviews/v1/analytics/analytics_api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaReviewsAnalyticsV1Service = bindHTTP(ReviewsAnalyticsAPI);
export const serviceName = 'reviews-analytics-v1' as const;
